import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import * as moment from 'moment';
import { Card, CardBody, CardHeader, Button, Col, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter, Row } from "reactstrap"







const ConfirmacionCita = () => {
    let { ID } = useParams();
    let { Tel } = useParams();
  

    const [Cita, SetCita] = useState([]);


    const obtenerDatos = async () => {
        let response = await fetch(Api + "Citas/ConsultaConfirmacionCita/"+ID+"/"+Tel);
        if (response.ok) {
            let data = await response.json()
            SetCita(data)
        }
    }
    useEffect(() => {
       
        obtenerDatos()
    }, [])

    const ConfirmarCita = async (e) => {
        let response = await fetch(Api + "Citas/ConfirmarCita/" + e.citaID + "/o/" + e.telefono );

        if (response.ok) {
            Swal.fire(
                'Cita Confirmada!',
                'Gracias.',
                'success'
            )
            obtenerDatos()
           
        }
    }
    const Cancelar =  () => {
        window.location.close();
    }
    return (
        <div style={{
            backgroundImage: 'url("./imagen/Diamond.jpg")', width: "100%", height: "100%", position: "absolute", backgroundPosition: "center"
            , backgroundRepeat:"no-repeat", backgroundSize:"cover"
        }}>
            
            <div style={{ textAlign: "center", margin: "20%", background: "#fff", fontSize: "30px", color: "#333",padding:"20px" } }>
            <div>
                <h1><b>Confirmación de cita</b></h1>
            </div>
                <br />
              

                {Cita.map(x => (  
              
                    <div >
                      

                        <div hidden={!x.confirmacionCita}>
                      <h3><b>Gracias su cita ya fue confirmada puede cerrar esta ventana.</b> </h3>
                        </div>
                        <div hidden={x.confirmacionCita}>
                    <p>Hola {x.nombrePaciente} favor confirmar su cita del {moment(x.fecha).format("DD/MM/YYYY")} a la {x.hora}. Para completar el proceso de
                       confirmacion con nosotros presionar boton Asistir que esta mas debajo.</p>

                    
                  

                    <Button color="primary" size="lg" className="mr-2"
                        onClick={() => ConfirmarCita(x)}
                    >
                        <i className="fas fa-check">ASISTIR</i>
                    </Button>
                    <Button color="danger" size="lg" className="mr-2" 
                        onClick={() => Cancelar()}     
                    >
                        <i className="fas ">CANCELAR</i>
                    </Button>
                   
                </div>
                </div>

            ))

            }
</div>
        </div>
    )

}
export default ConfirmacionCita;